module.exports = __webpack_public_path__ + "static/media/google-play-badge-id-2.e1a05cb3.gif";